import { render, staticRenderFns } from "./orderProcess.vue?vue&type=template&id=57521ae8&scoped=true&"
import script from "./orderProcess.js?vue&type=script&lang=js&"
export * from "./orderProcess.js?vue&type=script&lang=js&"
import style0 from "./orderProcess.vue?vue&type=style&index=0&id=57521ae8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57521ae8",
  null
  
)

export default component.exports